<div class="container">
	<div #canvas>
		<ng-content></ng-content>
	</div>
</div>